module.exports = __webpack_public_path__ + "static/media/1542318046126-1873150301 - Citizen Datasteward.6a32770c.jpg";